import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, map, Observable } from 'rxjs';
import { distinctUntilChanged, filter, withLatestFrom } from 'rxjs/operators';

import { getCmsConfigValue, getPage } from '@core/infrastructure/state/core.selectors';
import { selectActiveChat, selectChatVisible } from '@shared/chat/store/chat.selectors';

@Injectable()
/*
* Este servicio se encarga de orquestar la presentacion
* de los widget de chat | accesibilidad inyectados
* desde su componente (provider) de forma lazy
* */
export class AccessibilityChatWidgetUiService {
    private readonly getPage$ = this.store.select(getPage).pipe(
        filter(page => !!page)
    );

    private readonly accessibilityConfig$ = this.store.select(getCmsConfigValue('accessibilityConfig'));

    public isLightTheme$ = this.getPage$.pipe(
        withLatestFrom(this.accessibilityConfig$),
        map(([page, accessibilityConfig]) => {
            const pageHasAccessibilityConfig = accessibilityConfig?.[page] ?? 'light';
            return pageHasAccessibilityConfig === 'light';
        })
    );

    public isButtonCenteredByPage$ = this.getPage$.pipe(
        map(page => [
            'ItxProductPage',
            'ItxAngularGiftCardPage',
            'ItxGiftCardPage',
            'ItxShopCartPage',
            'ItxAngularShopcartPage',
            // eslint-disable-next-line no-secrets/no-secrets
            'ItxCheckoutShippingStorePage',
            // eslint-disable-next-line no-secrets/no-secrets
            'ItxCheckoutShippingStoreSummaryPage',
            'ItxCheckoutPaymentPage',
            // eslint-disable-next-line no-secrets/no-secrets
            'ItxCheckoutSummaryPage',

            'ItxCheckoutPage',
            // eslint-disable-next-line no-secrets/no-secrets
            'ItxAngularCheckoutPage',
            // eslint-disable-next-line no-secrets/no-secrets
            'ItxCheckoutShippingPage',
            // eslint-disable-next-line no-secrets/no-secrets
            'ItxCheckoutShippingDeliveryPage',
            // eslint-disable-next-line no-secrets/no-secrets
            'ItxCheckoutShippingDeliveryAddressPage',
            // eslint-disable-next-line no-secrets/no-secrets
            'ItxCheckoutShippingDeliverySummaryPage',
            // eslint-disable-next-line no-secrets/no-secrets
            'ItxCheckoutShippingDropPointSummaryPage',
            // eslint-disable-next-line no-secrets/no-secrets
            'ItxCheckoutShippingDropPointPage',
            'ItxCheckoutRepaymentPage',
        ].includes(page)),
    );

    public chatWidgetIsDisabled$: Observable<boolean> = combineLatest([
        this.store.select(selectActiveChat),
        this.store.select(selectChatVisible),
    ]).pipe(
        map(([activeChat, chatVisible]) => {
            return !activeChat && !chatVisible;
        }),
        distinctUntilChanged(),
    );

    constructor(private readonly store: Store) { }
}
